// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"e0fbd3b0","668":"59402f75"}[chunkId] + ".chunk.js";
};